import {get, post} from 'utils/axios/index'
import {toast} from 'react-toastify'
import {DefaultApiResponse} from 'models/ApiResponse'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import {IFormField} from 'models/Common'
import {
 ICounterOrderPayload,
 ICounterPreviewData,
} from 'models/OrderManagement'

const fetchOrderList = async (payload: IFormField) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/sales/web-order-history`, {
   ...payload,
  }).then((res) => {
   if (res) {
    return res
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchSaleOrderSummary = async (
 payload: IFormField
) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/sales/order-summary`, {
   ...payload,
  }).then((res) => {
   if (res) {
    return res
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchBuyerDetails = async (payload: IFormField) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(
   `/sales/aggregator-invoice-summary`,
   payload
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchOrderDetails = async (
 orderId: string,
 payload: IFormField
) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(
   `/sales/order-details/${orderId}`,
   payload
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const downloadInvoice = async (invoiceId: string) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(
   `/invoices/download/${invoiceId}`
  ).then((res) => {
   if (res?.invoice_s3_url) {
    return res.invoice_s3_url
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const updateOrderStatus = async (
 orderId: string,
 payload: IFormField
) => {
 try {
  return await (
   await post
  )<DefaultApiResponse>(
   `/sales/update-order-status/${orderId}/`,
   payload
  ).then((res) => {
   if (res.success) {
    return res.message
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchOrderCancellationRejectionReason = async (
 orderId: string,
 payload: IFormField
) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(
   `/sales/order-details/${orderId}`,
   payload
  ).then((res) => {
   if (res) {
    return res
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const sendOrderForConfirmation = async (
 orderId: string,
 payload: ICounterOrderPayload
) => {
 try {
  return await (
   await post
  )<DefaultApiResponse>(
   `/sales/order/${orderId}/counter/`,
   payload as unknown as Record<string, unknown>
  ).then((res) => {
   if (res.success) {
    return res.message
   }

   toast.error('Something went wrong')
   return null
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const previewOrderCounter = async (
 orderId: string,
 payload: ICounterOrderPayload
): Promise<ICounterPreviewData | null> => {
 try {
  return await (
   await post
  )<DefaultApiResponse>(
   `/sales/order/${orderId}/counter/preview/`,
   payload as unknown as Record<string, unknown>
  ).then((res) => {
   if (res.success) {
    return res.data as ICounterPreviewData
   }

   toast.error('Something went wrong')
   return null
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

export {
 fetchOrderList,
 fetchBuyerDetails,
 fetchOrderDetails,
 updateOrderStatus,
 fetchOrderCancellationRejectionReason,
 downloadInvoice,
 fetchSaleOrderSummary,
 sendOrderForConfirmation,
 previewOrderCounter,
}
